import type { PresentedApiError } from "@/lib/api/portal-error-copy";

type ApiErrorNoticeProps = {
  error: PresentedApiError;
  className?: string;
  testId?: string;
};

/** Human sentence plus the API code, for an existing alert paragraph. */
export function ApiErrorNotice({
  error,
  className,
  testId,
}: ApiErrorNoticeProps) {
  return (
    <p className={className} role="alert" data-testid={testId}>
      <span>{error.message}</span>
      {error.code ? <span className="api-error-code">{error.code}</span> : null}
    </p>
  );
}
